import { render, staticRenderFns } from "./VehicleDetailView.vue?vue&type=template&id=65c06c88&"
import script from "./VehicleDetailView.vue?vue&type=script&lang=ts&"
export * from "./VehicleDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports